(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5344],{

/***/ 20371:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/bin/prospections",
      function () {
        return __webpack_require__(33495);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var services_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17698);
/* harmony import */ var components_Layout_Admin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98946);





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Prospections = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return __webpack_require__.e(/* import() */ 1321).then(__webpack_require__.bind(__webpack_require__, 95310));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95310)
            ];
        }
    },
    ssr: false
});
var DashboardContent = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return __webpack_require__.e(/* import() */ 7716).then(__webpack_require__.bind(__webpack_require__, 97716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97716)
            ];
        }
    },
    ssr: false
});
var BinProspections = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(BinProspections, Component1);
    var _super = _createSuper(BinProspections);
    function BinProspections() {
        _classCallCheck(this, BinProspections);
        return _super.apply(this, arguments);
    }
    _createClass(BinProspections, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, filters = _props.filters, _url = _props.url, query = _url.query, pathname = _url.pathname;
                var _page = query.page, page = _page === void 0 ? 1 : _page;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Admin__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    pageRoles: [
                        'BROKER'
                    ],
                    pagePlans: [
                        services_config__WEBPACK_IMPORTED_MODULE_3__/* .PLANS.FULL_SERVICE */ .Xf.FULL_SERVICE,
                        services_config__WEBPACK_IMPORTED_MODULE_3__/* .PLANS.IN_HOUSE_FULL */ .Xf.IN_HOUSE_FULL,
                        services_config__WEBPACK_IMPORTED_MODULE_3__/* .PLANS.AFFILIATE */ .Xf.AFFILIATE,
                        services_config__WEBPACK_IMPORTED_MODULE_3__/* .PLANS.LITE */ .Xf.LITE,
                        services_config__WEBPACK_IMPORTED_MODULE_3__/* .PLANS.IN_HOUSE_RENT */ .Xf.IN_HOUSE_RENT,
                        services_config__WEBPACK_IMPORTED_MODULE_3__/* .PLANS.IN_HOUSE_SELL */ .Xf.IN_HOUSE_SELL, 
                    ],
                    urlData: {
                        query: query,
                        pathname: pathname
                    },
                    title: "Prospecciones para tus clientes",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DashboardContent, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Prospections, {
                            page: page
                        })
                    })
                }));
            }
        }
    ]);
    return BinProspections;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
BinProspections.getInitialProps = function(context) {
    return {};
};
/* harmony default export */ __webpack_exports__["default"] = (BinProspections);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4663,4895,9179,6940,3055,866,6066,7314,6959,9994,604,3300,4608,5206,2174,2470,553,7013,2593,2888,179], function() { return __webpack_exec__(20371); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);